module.exports = __webpack_public_path__ + "static/img/bg.134aa74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/header/bg.png
// module id = MnUg
// module chunks = 6